export enum LoadType {
  ALL = 'ALL',
  ORGANIZATION = 'ORGANIZATION',
}
